import './style.scss'
import dayjs from 'dayjs';
import { useState, useEffect } from 'react';

import utc from 'dayjs/plugin/utc'; // Import UTC plugin for dayjs
import timezone from 'dayjs/plugin/timezone'; // Import timezone plugin for dayjs

dayjs.extend(utc); // Enable the UTC plugin
dayjs.extend(timezone); // Enable the timezone plugin
import 'dayjs/locale/en'; // Import the locale you want to use
import Stream from './Stream';
import MasterControls from './MasterControls';

export default function VMS({
    unix_timestamp_s,
    trailer_time_zone,
    formatted_vms_config,
    location_name
}) {

    const [mainStreamIdx, setMainStreamIdx] = useState(1)
    const [mainStream, setMainStream] = useState(null)
    const [promotedStreams, setPromotedStreams] = useState([]) // Track promoted stream indices
    
    useEffect(() => {
        var idx = 1  // Start at 1 to match carousel
        if (Object.keys(formatted_vms_config).length > 0) {
            for (const [camera_type, camera] of Object.entries(formatted_vms_config)) {
                for (const [camera_name, streams] of Object.entries(camera)) {
                    var stream_info = {
                        camera_type:camera_type,
                        camera_name:camera_name,
                        index:idx
                    }
                    streams?.map((stream, stream_idx) => {
                        if (stream.stream_resolution.name == "low"){
                            stream_info['streamId'] = stream.id
                        } 
                        if (stream.stream_resolution.name == "high"){
                            stream_info['highResID'] = stream.id                            
                        }
                        if (stream.stream_resolution.name == "periscope"){
                            stream_info['periscopeID'] = stream.id                            
                        }
                    })
                    
                    if (idx === mainStreamIdx) {
                        setMainStream(stream_info)
                    }
                    idx = idx + 1  // Increment AFTER the check
                }
            }
        }
    }, [mainStreamIdx, formatted_vms_config])

    // Handler to toggle stream promotion
    const handlePromoteToggle = (streamIndex) => {
        setPromotedStreams(prev => {
            if (prev.includes(streamIndex)) {
                // Demote: remove from promoted list
                return prev.filter(idx => idx !== streamIndex)
            } else {
                // Promote: add to list (max 2)
                if (prev.length < 2) {
                    return [...prev, streamIndex]
                }
                return prev // Already at max
            }
        })
    }

    // Helper to get all stream info
    const getAllStreams = () => {
        const streams = []
        let idx = 1
        if (Object.keys(formatted_vms_config).length > 0) {
            for (const [camera_type, camera] of Object.entries(formatted_vms_config)) {
                for (const [camera_name, streams_data] of Object.entries(camera)) {
                    var stream_info = {
                        camera_type: camera_type,
                        camera_name: camera_name,
                        index: idx
                    }
                    streams_data?.forEach((stream) => {
                        if (stream.stream_resolution.name === "low") {
                            stream_info['streamId'] = stream.id
                        } 
                        if (stream.stream_resolution.name === "high") {
                            stream_info['highResID'] = stream.id                            
                        }
                        if (stream.stream_resolution.name === "periscope") {
                            stream_info['periscopeID'] = stream.id                            
                        }
                    })
                    streams.push(stream_info)
                    idx++
                }
            }
        }
        return streams
    }

    const allStreams = getAllStreams()

    if (formatted_vms_config.length === 0) {
        return (
            <div className='vms'>
                No Camera Data
            </div>
        )
    }

    return (
        <div className='vms'>
            <div className='page-container vertival-center'>

                <div className='main-video-container'>                    
                    {/* Main stream */}
                    {mainStream && (
                        <Stream
                            camera_type={mainStream.camera_type}
                            camera_name={mainStream.camera_name}
                            index={0}
                            streamId={mainStream.streamId}
                            highResID={mainStream.highResID}
                            periscopeID={mainStream.periscopeID}
                            starting_timestamp={unix_timestamp_s}
                            onPromoteToggle={handlePromoteToggle}
                            isPromoted={false}
                            canPromote={false} // Main stream can't be promoted/demoted
                            promotedCount={promotedStreams.length}
                            location_name={location_name}
                        />
                    )}
                    
                    {/* Promoted streams */}
                    {allStreams
                        .filter(stream => promotedStreams.includes(stream.index) && stream.streamId != null)
                        .map(stream => (
                            <Stream
                                key={`promoted-${stream.index}`}
                                camera_type={stream.camera_type}
                                camera_name={stream.camera_name}
                                index={stream.index}
                                streamId={stream.streamId}
                                highResID={stream.highResID}
                                periscopeID={stream.periscopeID}
                                starting_timestamp={unix_timestamp_s}
                                onPromoteToggle={handlePromoteToggle}
                                isPromoted={true}
                                canPromote={true}
                                promotedCount={promotedStreams.length}
                                location_name={location_name}
                            />
                        ))
                    }
                </div>
                
                <MasterControls
                    time_zone={trailer_time_zone}
                    unix_timestamp_s={unix_timestamp_s}
                />
                <div className='row'>
                    <div className='carouselContainer'>
                    {Object.keys(formatted_vms_config).length > 0 && 
                        (() => {
                            let streamIndex = 1; // Start at 1 since main stream is 0
                            return Object.entries(formatted_vms_config).flatMap(([camera_type, camera]) => 
                                Object.entries(camera).map(([camera_name, streams]) => {
                                    const currentIndex = streamIndex++;
                                    
                                    // Skip if this stream is promoted
                                    // Show placeholder if this stream is promoted
                                    if (promotedStreams.includes(currentIndex)) {
                                        return (
                                            <div 
                                                key={`placeholder-${currentIndex}`} 
                                                className='carouselCard carouselPlaceholder'
                                            >
                                                <div className='theater-mode-placeholder'>
                                                    <span>Video in Theater Mode</span>
                                                </div>
                                            </div>
                                        );
                                    }
                                    
                                    var stream_info = {
                                        camera_type: camera_type,
                                        index: currentIndex
                                    };
                                    
                                    streams?.forEach((stream) => {
                                        if (stream.stream_resolution.name === "low") {
                                            stream_info['streamId'] = stream.id;
                                        } 
                                        if (stream.stream_resolution.name === "high") {
                                            stream_info['highResID'] = stream.id;                            
                                        }
                                        if (stream.stream_resolution.name === "periscope") {
                                            stream_info['periscopeID'] = stream.id                            
                                        }
                                    });

                                    return (
                                        
                                        <div 
                                            key={`${camera_type}-${camera_name}-${currentIndex}`} 
                                            className='carouselCard' 
                                            onClick={() => setMainStreamIdx(currentIndex)}
                                        >
                                            <Stream
                                                camera_type={camera_type}
                                                camera_name={camera_name}
                                                index={currentIndex}
                                                streamId={stream_info['streamId']}
                                                highResID={stream_info['highResID']}
                                                periscopeID={stream_info['periscopeID']}
                                                starting_timestamp={unix_timestamp_s}
                                                onPromoteToggle={handlePromoteToggle}
                                                isPromoted={false}
                                                canPromote={true}
                                                promotedCount={promotedStreams.length}
                                                location_name={location_name}
                                            />
                                        </div>
                                    );
                                })
                            );
                        })()
                    }
                </div>
            </div>
        </div>
    </div>
)}
